module.exports = __webpack_public_path__ + "static/media/verified.c85eb258.jpeg";